import { State } from "src/state";

export const getSupportedLanguages = (state: State) =>
  state.userPreferences && state.userPreferences.supportedLanguages;

export const getUserPreferences = (state: State) => state.userPreferences;

export const getClientConfig = (state: State) => state.clientMetadata;

export const showUserPreferences = (state: State) =>
  Boolean(state.clientMetadata.useCOATranslation);



// WEBPACK FOOTER //
// ./src/topNav/selector.ts